/* Cart button in the top-right of the header on every page, with a live item count (18 Oct 2026) */
(function () {
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 3.5h2.2l2.5 11a1.6 1.6 0 0 0 1.6 1.2h8.4a1.6 1.6 0 0 0 1.5-1.1l2.1-6.6H6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.6" cy="19.8" r="1.6"/><circle cx="17" cy="19.8" r="1.6"/></svg>';
  function css() {
    if (document.getElementById('agcart-css')) return;
    var s = document.createElement('style'); s.id = 'agcart-css';
    s.textContent = '.agcart{position:relative;display:inline-grid;place-items:center;flex:0 0 auto;width:44px;height:44px;margin-left:.6rem;margin-right:-.4rem;border-radius:50%;color:#fff;text-decoration:none}' +
      '.agcart:hover,.agcart:focus-visible{background:rgba(255,255,255,.12)}' +
      '.agcart svg{width:25px;height:25px;fill:currentColor}' +
      '.agcart__n{position:absolute;top:1px;right:-1px;min-width:19px;height:19px;padding:0 5px;box-sizing:border-box;border-radius:10px;background:var(--gold,#F5B335);color:var(--black,#211E16);font:800 12px/19px "Dosis",system-ui,sans-serif;text-align:center}' +
      '.agcart__n[hidden]{display:none}';
    document.head.appendChild(s);
  }
  function count() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        document.querySelectorAll('.agcart').forEach(function (a) {
          var b = a.querySelector('.agcart__n');
          b.textContent = n > 99 ? '99+' : n; b.hidden = !n;
          a.setAttribute('aria-label', n ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart');
        });
      }).catch(function () {});
  }
  function go() {
    css();
    document.querySelectorAll('header.bar .bar__in').forEach(function (bar) {
      if (bar.querySelector('.agcart')) return;
      var a = document.createElement('a'); a.href = '/cart'; a.className = 'agcart'; a.setAttribute('aria-label', 'Cart');
      a.innerHTML = ICON + '<span class="agcart__n" hidden>0</span>';
      bar.appendChild(a);
    });
    count();
  }
  /* refresh the count whenever something is added, changed or removed */
  var f = window.fetch;
  if (f) window.fetch = function (u) {
    var p = f.apply(this, arguments);
    try { var s = typeof u === 'string' ? u : (u && u.url) || ''; if (/\/cart\/(add|change|update|clear)/.test(s)) p.then(function () { setTimeout(count, 200); }, function () {}); } catch (e) {}
    return p;
  };
  addEventListener('pageshow', function (e) { if (e.persisted) count(); });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', go) : go();
})();
